import React from 'react';

import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';

const HealthWarning = () => {
    const localizedStrings = getLocalizedStrings();

    return (
        <div className='flex items-center justify-center bg-secondary px-16 py-7 lg:py-8'>
            <div className='leading-14_3 max-w-max text-14 font-bold tracking-02 text-primary md:text-16 md:leading-15'>
                {localizedStrings[localizationKeys.NOT_AVAILABLE_PAGE_INFORMATION_SECTION_TEXT]}
            </div>
        </div>
    );
};

export default HealthWarning;
